import { Box, Typography } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import { MotionContainer, varBounceInLeft, varBounceOutRight } from '../animate';

import { useWSContext } from '../../context/WebSocketContext';
import { useAuthContext } from '../../context/AuthContext';
import BoxAtendente from './BoxAtendente';

function ListAtendentesOnline() {
  const { atendentesOnline } = useWSContext();
  const { cliente } = useAuthContext();

  const atendentesFiltrados = atendentesOnline?.filter(
    (atendente) => atendente?.id !== cliente?.id
  );

  return (
    <Box>
      <AnimatePresence>
        {atendentesFiltrados?.map((atendente) => (
          <MotionContainer key={atendente.id} initial="initial" open exit="exit">
            <motion.div
              key="animacao"
              variants={varBounceInLeft}
              exit={varBounceOutRight}
            >
              <BoxAtendente key={atendente?.id} atendente={atendente} />
            </motion.div>
          </MotionContainer>
        ))}

        {atendentesFiltrados?.length === 0 && (
          <Box>
            <MotionContainer initial="initial" open>
              <motion.div variants={varBounceInLeft}>
                <Typography variant="caption">
                  Nenhum atendente disponível no momento
                </Typography>
              </motion.div>
            </MotionContainer>
          </Box>
        )}
      </AnimatePresence>
    </Box>
  );
}

export default ListAtendentesOnline;
